(function () {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('single-post') || document.body.classList.contains('page')) {
      const postThumb = document.querySelector('.article-thumbnail.is-clickable');
      const postToplist = document.querySelector('.toplist');

      if (postThumb && postToplist && (window.innerWidth < 768)) {
        const adminBar = document.getElementById('wpadminbar');
        const offset = adminBar
          ? postToplist.getBoundingClientRect().top + window.pageYOffset - Math.round(adminBar.offsetHeight) - 100
          : postToplist.getBoundingClientRect().top + window.pageYOffset - 120;

        postThumb.style.cursor = 'pointer';
        postThumb.addEventListener('click', function (event) {
          event.preventDefault();

          window.scrollTo({
            top: offset,
            behavior: 'auto'
          });
        });
      }
    }
  });
})();